module.exports = __webpack_public_path__ + "img/vuejs.35e69165.jpeg";